/** Canonical processor wins over incidental accounts; legacy records use provider identity. */
export function paymentProcessor(merchant) {
  const explicit = merchant?.defaultPaymentProcessor;
  if (typeof explicit === 'string' && explicit.trim()) return explicit.trim().toUpperCase();
  if (merchant?.stripeAccountID || merchant?.stripeDetails?.accountId) return 'STRIPE';
  if (merchant?.merchantIdentity || merchant?.finixDetails?.identityId) return 'FINIX';
  return null;
}

export function getStripeAccountId(merchant) {
  return merchant?.stripeDetails?.accountId || merchant?.stripeAccountID || '';
}

export function hasStripeAccountConflict(merchant) {
  return Boolean(merchant?.stripeDetails?.accountId && merchant?.stripeAccountID
    && merchant.stripeDetails.accountId !== merchant.stripeAccountID);
}

/** Payment eligibility is independent of subscription tier and tutorial progress. */
export function canAcceptPayments(merchant) {
  const processor = paymentProcessor(merchant);
  if (processor === 'FINIX') return Boolean((merchant?.merchantIdentity || merchant?.finixDetails?.identityId) && (merchant?.merchantID || merchant?.finixDetails?.merchantId));
  if (processor && processor !== 'STRIPE') return false;
  return Boolean(getStripeAccountId(merchant)) && !hasStripeAccountConflict(merchant) && merchant?.stripeDetails?.chargesEnabled === true
    && merchant?.stripeDetails?.statusSnapshot?.chargesEnabled !== false;
}

export function canShareForm(merchant, form) {
  return canAcceptPayments(merchant) && form?.active === true;
}

export function paymentOrganizationKey(merchant) {
  return merchant?.clerkOrganizationId || merchant?.organizationId || merchant?.merchantID || merchant?.id || '';
}
